import React from 'react' // eslint-disable-line

import styled from 'styled-components'
export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  [data-type='link'] {
    color: #333333;
    cursor: pointer;
    font-weight: normal;
    text-decoration: underline;
  }
  [data-type='slideshow'] {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    [data-type='slider'] {
      white-space: nowrap;
      [data-type='slide'] {
        display: inline-block;
        opacity: 0.3;
        transition: opacity 0.7s ease-in-out;
        height: 400px;
        width: 100%;
        position: relative;
        img {
          object-fit: cover;
          object-position: top center;
          width: 100%;
        }
        &[data-style='active'] {
          opacity: 1;
        }
        [data-type='content'] {
          position: absolute;
          top: 19rem;
          left: 12rem;
          width: 300px;
          height: 450px;
          background: #ffffff;
          opacity: 0.8;
          transform: translate(-50%, -50%);
          padding: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          hr {
            width: 80px;
          }
          p {
            white-space: pre-wrap;
            text-align: center;
            &[data-type='title'] {
              font-weight: bold;
            }
            &[data-type='user'] {
              margin-bottom: 0px;
              margin-top: 16px;
            }
            &[data-type='comment'] {
              margin-top: 16px;
            }
            &[data-type='location'] {
              margin-top: 10px;
              font-size: 12px;
              color: #666666;
            }
          }
        }
      }
    }
    [data-type='dots'] {
      text-align: center;
      margin-top: 30px;
      [data-type='dot'] {
        display: inline-block;
        height: 8px;
        width: 8px;
        border-radius: 50%;

        cursor: pointer;
        margin: 15px 7px 0px;

        background: #fffff;
        border: 1px solid #000000;
        &[data-style='active'] {
          background: #000000;
        }
      }
    }
  }
  [data-type='black-button'] {
    width: 100%;
    max-width: 343px;
    height: 58px;
    background: #333333;
    color: #ffffff;
    border: none;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  [data-type='hero-image'] {
    position: relative;
    img {
      width: 100%;
      object-fit: cover;
      object-position: center center;
    }
    [data-type='overlay'] {
      position: absolute;
      height: 454px;
      width: 100%;
      z-index: 1;
      background: rgba(0, 0, 0, 0.4);
    }
    h2 {
      z-index: 2;
      margin: 0;
    }
    h1,
    h2 {
      font-weight: normal;
    }
    h1,
    h2 {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #f3f3f3;
      font-size: 60px;
    }
    [data-style='hero-button'] {
      position: absolute;
      top: 75%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
    }
  }
  [data-type='why-sell'] {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 70px;
    padding: 0 20px;
    [data-type='title'] {
      font-size: 60px;
      color: #333;
      margin: 0;
    }
    [data-type='sub-title'] {
      font-size: 24px;
      color: #333;
      margin: 0;
      margin-top: 24px;
    }
    [data-type='stat-grid'] {
      margin-top: 80px;
      max-width: 850px;
      p {
        font-size: 14px;
        font-weight: bold;
        margin: 0;
      }
      h4 {
        font-size: 26px;
        font-weight: 300;
        margin: 0;
      }
      [data-type='bottom-row'] {
        margin-top: 16px;
      }
      h5 {
        font-size: 24px;
        font-weight: 300;
        margin: 0;
      }
      [data-type='stat-grid-row'] {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
      }
      [data-type='stat-grid-item'] {
        text-align: center;
        padding: 1rem 0.05rem;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        @media (min-width: 767px) {
          flex-grow: 1;
        }
        @media (min-width: 992px) {
          flex-grow: 0;
        }
        &[data-style='stretch'] {
          @media (max-width: 992px) {
            flex-grow: 1;
          }
        }
        &[data-style='wrap'] {
          flex-grow: 1;
          white-space: normal;
          @media (min-width: 992px) {
            flex-grow: 0;
            max-width: 370px;
          }
        }
      }
      [data-type='stat-border'] {
        display: inline-block;
        height: 80px;
        width: 1px;
        background-color: #cbcbcb;
        &[data-style='goes-horizontal'] {
          width: 100%;
          height: 1px;
          @media (min-width: 992px) {
            height: 80px;
            width: 1px;
          }
        }
      }
      [data-type='stat-border-reverse'] {
        display: inline-block;
        height: 1px;
        width: 100%;
        margin: 1rem 0;
        background-color: #cbcbcb;
        @media (max-width: 992px) {
          height: 80px;
          width: 1px;
        }
      }
    }
  }
  [data-type='verify-account'] {
    height: 354px;
    width: 100%;
    background: #f6f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 40px;
    p {
      font-size: 56px;
      margin-top: 20px;
      max-width: 719px;
      text-align: center;
      margin-bottom: 40px;
    }
  }
  [data-type='block'] {
    display: flex;
    flex-direction: row;
    [data-type='block-title'] {
      font-size: 30px;
      margin: 0;
    }
    [data-type='block-text'] {
      margin-right: 101px;
      max-width: 440px;
      &[data-style='second-item'] {
        margin-right: 0;
        margin-left: 101px;
      }
    }
    [data-type='block-image'] {
      display: flex;
      align-items: center;
    }
    &[data-style='tools-team'] {
      [data-type='block-sub-text'] {
        margin-top: 20px;
        span {
          font-weight: bold;
        }
      }
    }
    &[data-style='share'] {
      margin-bottom: 65px;
      [data-type='block-text'] {
        display: flex;
        justify-content: center;
        flex-direction: column;
      }
      [data-type='block-sub-text'] {
        margin-top: 20px;
        span {
          font-weight: bold;
        }
      }
    }
    [data-type='block-sub-text'] {
      margin-top: 34px;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.02em;
      color: #333333;
    }
    [data-type='block-list'] {
      margin-top: 34px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.02em;
      li {
        margin-bottom: 15px;
      }
    }
  }
  [data-type='block-wrapper'] {
    max-width: 1256px;
    margin: 0 auto;
    padding: 0 20px;
    margin-top: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    hr {
      width: 100%;
      border: 1px solid #dcdcdc;
      margin-top: 65px;
    }
    [data-style='benefits-button'] {
      margin-top: 70px;
    }
  }
  [data-type='support'] {
    margin-top: 47px;
    padding-top: 45px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 30px;
    align-items: center;
    display: flex;
    flex-direction: column;
    background: #f6f5f5;
    height: 460px;
    width: 100%;
    [data-type='title'] {
      font-size: 30px;
      margin: 0;
    }
    [data-type='item-row'] {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      margin-bottom: 30px;
      justify-content: center;
      [data-type='item'] {
        max-width: 370px;
        padding: 16px;
        width: 100%;
        text-align: center;
        [data-type='sub-title'] {
          color: #333333;
          font-weight: 600;
          margin-bottom: 16px;
          margin-top: 0;
        }
        [data-type='text'] {
          line-height: 1.5;
          margin-bottom: 0;
        }
      }
    }
  }
  [data-type='faq'] {
    width: 100%;
    height: 100%;
    background: #f7f6f6;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 47px;
    padding-bottom: 40px;
    [data-type='title'] {
      font-size: 30px;
      line-height: 34px;
      margin-top: 73px;
      margin-bottom: 56px;
    }
    [data-type='more-info'] {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.02em;
      margin: 24px 0;
      padding: 0 20px;
    }
    [data-type='button-row'] {
      display: flex;
      flex-direction: row;
      [data-type='button-link'] {
        width: 238px;
        height: 58px;
        border: 2px solid #000000;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        padding-top: 17px;
        cursor: pointer;
        text-decoration: none;
        color: #333333;
        &:first-child {
          margin-right: 24px;
        }
      }
    }
    section {
      width: 856px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #dcdcdc;
      + section {
        border-top: none;
      }
      svg[data-type='arrow'] {
        width: 15px;
        height: 15px;
        margin-left: 15px;
        path {
          stroke: #666666;
          stroke-width: 1.8;
        }
        &[open] {
          transform: rotate(180deg);
        }
      }
      [data-style='toggle-element'] {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.2s ease-in-out;

        &[data-visible] {
          max-height: 1500px;
        }
        p {
          font-size: 14px;
          line-height: 1.6;
          margin-top: 0;
        }
      }

      fieldset {
        display: flex;
        flex-direction: column;
        border: none;
        padding: 0;
        margin: 0;
        width: 100%;
        min-height: 70px;
      }

      /* No FOCUS on MOBILE */
      [data-type='header'],
      [tabIndex] {
        &:focus {
          @media (max-width: 992px) {
            outline: none;
          }
        }
      }

      [data-type='header'] {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        cursor: pointer;
        h2 {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          margin: 25px 0;
        }
      }
    }
  }
  @media (max-width: 992px) {
    [data-type='hero-image'] {
      img {
        object-position: right center;
      }
      &[data-style='bottom-hero'] {
        img {
          object-position: 57% center;
        }
      }
      h1,
      h2 {
        font-size: 40px;
        max-width: 343px;
        width: 100%;
      }
    }
    [data-type='slideshow'] {
      [data-type='slider'] {
        [data-type='slide'] {
          [data-type='content'] {
            left: 50%;
          }
        }
      }
    }
    [data-type='why-sell'] {
      margin-top: 45px;
      [data-type='title'] {
        font-size: 30px;
        text-align: center;
      }
      [data-type='sub-title'] {
        font-size: 18px;
        margin-top: 20px;
      }
      [data-type='stat-grid'] {
        margin-top: 40px;
        p {
          font-size: 12px;
        }
        h4,
        h5 {
          font-size: 22px;
        }
      }
    }
    [data-type='verify-account'] {
      height: 282px;
      margin-top: 0;
      p {
        font-size: 32px;
        margin-top: 0px;
        margin-bottom: 24px;
        max-width: 339px;
      }
    }
    [data-type='block-wrapper'] {
      margin: 20px;
      margin-bottom: 0px;
      padding: 0;
      hr {
        margin: 0;
      }
      [data-style='benefits-button'] {
        margin-top: 4px;
        margin-bottom: 29px;
      }
      [data-style='share-button'] {
        margin-top: 0px;
      }
    }
    [data-type='support'] {
      height: 100%;
      margin-top: 14px;
      padding-top: 30px;
      padding-bottom: 20px;
      [data-type='item-row'] {
        flex-direction: column;
        margin-top: 0;
        margin-bottom: 20px;
        [data-type='item'] {
          margin-top: -20px;
        }
      }
    }
    [data-type='faq'] {
      [data-type='title'] {
        font-size: 30px;
        margin-top: 35px;
        margin-bottom: 10px;
        text-align: center;
      }
      [data-type='button-row'] {
        flex-direction: column;
        padding: 0 20px;
        [data-type='button-link'] {
          &:first-child {
            margin-bottom: 18px;
          }
        }
      }
      section {
        width: 500px;
        [data-type='header'] {
          h2 {
            font-size: 16px;
            margin: 20px 0;
          }
        }
        [data-style='toggle-element'] {
          p {
            margin-top: 0;
          }
        }
      }
    }
    [data-type='block'] {
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      &[data-style='benefits'] {
        flex-direction: column-reverse;
      }
      &[data-style='tools-team'] {
        flex-direction: column-reverse;
        [data-type='block-text'] {
          [data-type='block-sub-text'] {
            margin-top: 20px;
            &:last-child {
              margin-bottom: 20px;
            }
          }
        }
      }
      &[data-style='share'] {
        margin-bottom: 20px;
        [data-type='block-text'] {
          [data-type='block-sub-text'] {
            margin-top: 20px;
            &:last-child {
              margin-bottom: 20px;
            }
          }
        }
      }
      [data-type='block-image'] {
        img {
          width: 351px;
          height: 343px;
          object-fit: cover;
        }
      }
      [data-type='block-text'] {
        width: 100%;
        margin: 0;
        max-width: 590px;
        &[data-style='second-item'] {
          margin: 0;
        }
        [data-type='block-title'] {
          text-align: center;
          margin-top: 24px;
        }
        [data-type='block-sub-text'] {
          margin-top: 24px;
        }
        [data-type='block-list'] {
          padding-left: 20px;
          margin-top: 12px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    [data-type='faq'] {
      section {
        width: 343px;
      }
    }
  }
`
export const ConfirmationModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 525px;
  padding: 48px;
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    padding: 48px 16px;
  }
  [data-style='header'] {
    color: #333333;
    margin-bottom: 16px;
    text-align: center;
    [data-action='close'] {
      width: 18px;
      height: 18px;
      cursor: pointer;
      margin-top: -30px;
      path {
        stroke-width: 3px;
      }
    }
  }
  [data-type='modal-button-row'] {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    margin-top: 48px;
    margin-bottom: 16px;
  }
  [data-type='cancel-button'] {
    border: 1px solid #333333;
    background: none;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    padding: 16px 32px 16px 32px;
    height: 50px;
    cursor: pointer;
    color: #333333;
  }
  [data-type='continue-button'] {
    border: none;
    background: #333333;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    padding: 16px 32px 16px 32px;
    height: 50px;
    color: #ffffff;
    margin-left: 48px;
    cursor: pointer;
  }
  [data-type='recaptcha'] {
    margin-top: 8px;
    p {
      text-align: center;
    }
  }
  @media (max-width: 600px) {
    max-width: 350px;
  }
`
